import animateModal from './modal'
import animateNav from './nav'
import animatePreload from './preload'

export { animateModal, animateNav, animatePreload }
